import { CSSProperties, FC, useContext, useMemo } from "react";

import { Grid, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { Button, Color } from "capitalrx-components-2.0/lib/general";
import { createButtonType } from "capitalrx-components-2.0/lib/general/Button/ButtonAppearances";

import { LanguageSwitcher } from "@/common/components";
import { EnrollmentContext } from "@/state";
import { useTranslation } from "react-i18next";
import "./ThemedHeader.scss";


const CONTAINER_HEIGHT = "80px";

export const ThemedHeader: FC = () => {
  const [state] = useContext(EnrollmentContext);
  const theme = state.experienceData?.theme;
  const { t: translate } = useTranslation();
  const { setLogoFlush } = useResponsive(
    useMemo(
      () => ({
        setLogoFlush: { desktop: false, tablet: false, mobile: true },
      }),
      [],
    ),
  );

  const headerButtonAppearance = createButtonType("header-button", Color.DarkGrey[700], Color.DarkGrey[700]).Tertiary.Small;

  return (
    <div className={setLogoFlush ? "themed-header themed-header-mobile" : "themed-header"}>
      <Grid>
        {!setLogoFlush && <Grid.Span columns={1} />}
        <Grid.Span columns={setLogoFlush ? 12 : 10}>
          <Shelf alignment="center" spacing="large">
            <div className="themed-header-logo-container">
              <img className="themed-header-logo" src={theme?.logo_desktop} alt="client logo" />
            </div>
            <Button appearance={headerButtonAppearance}>{translate("ENROLLMENT_HOME.header.plans")}</Button>
            <Button appearance={headerButtonAppearance}>{translate("ENROLLMENT_HOME.header.comparePlans")}</Button>
            <Shelf.Spacer />
            <LanguageSwitcher />
          </Shelf>
        </Grid.Span>
        {!setLogoFlush && <Grid.Span columns={1} />}
      </Grid>
    </div>
  );
};

export const ThemedGradient: FC = () => {
  const style: CSSProperties = {
    // borderBottom: `solid 6px ${theme?.primary_color || "#313e48"}`,
    top: CONTAINER_HEIGHT,
  };

  return <div className="themed-gradient" style={style} />;
};
